import { partnerApiRequest } from 'core/service-wrapper/partner-api/handler-request/service-request'

export const partnerApiSubmissionData = {
  nationality: async () => {
    return await partnerApiRequest.getNationality()
  },
}
